import React, { Dispatch } from 'react'
import { applicationDataAction, personDataAction } from '../types/actions-reducer.type';
import { personDataState } from '../interfaces/state-data.interface';
import { ApplicationDataState } from '../interfaces/application-data.interface';

export interface SinatureDataState{
    stateData:{personDataState: personDataState, applicationDataState: ApplicationDataState}, dispatch:{personDataDispatch: Dispatch<personDataAction>, 
        applicationDataDispatch: Dispatch<applicationDataAction>
    } 
}

export const ElectronicSignatureContext = React.createContext<SinatureDataState>(null!);